import { render, staticRenderFns } from "./page_add_diy.vue?vue&type=template&id=661b002a&scoped=true"
import script from "./page_add_diy.vue?vue&type=script&lang=js"
export * from "./page_add_diy.vue?vue&type=script&lang=js"
import style0 from "./page_add_diy.vue?vue&type=style&index=0&id=661b002a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b002a",
  null
  
)

export default component.exports